import React from 'react'
import PageBanner from '../common/PageBanner'
import SubscribeComp from '../common/SubscribeComp'

export default function Contact() {
  return (
    <div className="contactpage">
      <PageBanner 
        title="Contact Us"
      />
      <SubscribeComp />
    </div>
  )
}